export default [
    { //用户列表
        path: '/userManagement',
        name:'userManagement',
        meta: { title: '用户列表'},
        component: () => import('../../views/userManagement/index.vue')
    },
    { //用户明细
        path: '/userManagement/detail',
        name:'userManagementDetail',
        meta: { title: '用户明细'},
        component: () => import('../../views/userManagement/detail.vue')
    },
    { //新增用户
      path: '/userManagement/add',
      name:'userManagementAdd',
      meta: { title: '新增用户'},
      component: () => import('../../views/userManagement/add.vue')
    },
    { //编辑用户
      path: '/userManagement/edit/:id?',
      name:'userManagementEdit',
      meta: { title: '编辑用户'},
      component: () => import('../../views/userManagement/edit.vue')
    },
    { //移交客户经理
      path: '/userManagement/move',
      name:'userManagementMove',
      meta: { title: '移交客户经理'},
      component: () => import('../../views/userManagement/move.vue')
    },
    { //被锁用户列表
      path: '/userManagement/unlock',
      name:'userManagementMoveUnlock',
      meta: { title: '被锁用户列表'},
      component: () => import('../../views/userManagement/unlock.vue')
    }
]